import { signInWithLink } from "amazon-cognito-passwordless-auth/magic-link";
import { type TokensFromStorage } from "amazon-cognito-passwordless-auth/storage";
import { retrieveValidTokens } from "./retrieveValidTokens";

export async function getTokens(): Promise<TokensFromStorage | undefined> {
  const signedInResponse = signInWithLink();
  await signedInResponse.signedIn;
  return retrieveValidTokens();
}
